import {
  GET_ALL_JACKPOTS,
  GET_ALL_JACKPOTS_RESPONSE_SUCCESS,
  CREATE_JACKPOT,
  UPDATE_JACKPOT,
  DELETE_JACKPOT,
} from "./actionTypes"

export const getAllJackpots = () => {
  return {
    type: GET_ALL_JACKPOTS,
  }
}
export const getAllJackpotsResponseSuccess = payload => ({
  type: GET_ALL_JACKPOTS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createJackpot = (payload, history) => {
  return {
    type: CREATE_JACKPOT,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateJackpot = (payload, history, redirectTo) => {
  return {
    type: UPDATE_JACKPOT,
    payload: payload,
    history,
    redirectTo,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteJackpot = payload => ({
  type: DELETE_JACKPOT,
  payload: payload,
})
